export const MAIN_DASHBOARD_GET_DATA_PAYMENTS = "main/dashboard/MAIN_DASHBOARD_GET_DATA_PAYMENTS"
export const MAIN_DASHBOARD_GET_DATA_PAYMENTS_RESULT = "main/dashboard/MAIN_DASHBOARD_GET_DATA_PAYMENTS_RESULT"

export const MAIN_DASHBOARD_GET_LIQUIDATION = "main/dashboard/MAIN_DASHBOARD_GET_LIQUIDATION"
export const MAIN_DASHBOARD_GET_LIQUIDATION_RESULT = "main/dashboard/MAIN_DASHBOARD_GET_LIQUIDATION_RESULT"